"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCreditFullPriceClick = trackCreditFullPriceClick;
var _analytics = require("@cian/analytics");
function trackCreditFullPriceClick() {
  (0, _analytics.ca)('eventSite', {
    name: 'oldevent',
    category: 'Card',
    action: 'click_info',
    label: 'open_loan_full_price_info',
    useLastProducts: true
  });
}